<template>
  <div>
    <b-card
      no-body
      class="mb-2"
    >
      <b-card-header class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <feather-icon
            icon="SendIcon"
            size="20"
            class="text-primary mr-1"
          />
          <h4 class="mb-0">
            Signal Launcher
          </h4>
        </div>
        <b-badge variant="light-primary">
          Preview zorunlu
        </b-badge>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="3"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">İndikatör</label>
            <b-form-select
              v-model="form.engineKey"
              :options="indicatorOptions"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Market</label>
            <b-form-select
              v-model="form.market"
              :options="marketOptions"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Mod</label>
            <b-form-select
              v-model="form.mode"
              :options="modeOptions"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Timeframe</label>
            <b-form-input
              v-model="form.timeframes"
              placeholder="30m,1h,4h"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Coinler</label>
            <b-form-input
              v-model="form.coins"
              placeholder="Boşsa aktif coinler · BTCUSDT, ETHUSDT"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">TP / SL</label>
            <div class="d-flex">
              <b-form-input
                v-model.number="form.tpPerc"
                type="number"
                step="0.1"
                class="mr-50"
              />
              <b-form-input
                v-model.number="form.slPerc"
                type="number"
                step="0.1"
              />
            </div>
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Kaldıraç</label>
            <b-form-input
              v-model.number="form.leverage"
              type="number"
              min="1"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Bot başı margin</label>
            <b-form-input
              v-model.number="form.marginPerBot"
              type="number"
              min="0"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Top N</label>
            <b-form-input
              v-model.number="form.topNResults"
              type="number"
              min="1"
              max="200"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Atama</label>
            <b-form-select
              v-model="assignment.mode"
              :options="assignmentOptions"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Bot oluşturma</label>
            <b-form-input
              v-model.number="assignment.maxBotsToCreate"
              type="number"
              min="0"
              max="100"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="mb-1 d-flex align-items-end"
          >
            <b-form-checkbox
              v-model="filters.onlyFresh"
              switch
              class="mr-2"
            >
              Sadece fresh
            </b-form-checkbox>
            <b-form-checkbox
              v-model="assignment.allowSameSymbolMultipleBots"
              switch
            >
              Aynı coine izin ver
            </b-form-checkbox>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
          <b-button
            variant="primary"
            :disabled="scanLoading"
            @click="runScan"
          >
            <feather-icon
              icon="SearchIcon"
              size="16"
              class="mr-50"
            />
            Sinyal Tara
          </b-button>
        </div>
      </b-card-body>
    </b-card>

    <b-row>
      <b-col
        cols="12"
        lg="8"
      >
        <b-card
          no-body
          class="mb-2"
        >
          <b-card-header class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">
              Sinyal Adayları
            </h5>
            <span class="text-muted font-small-3">
              {{ selectedCandidates.length }} seçili · {{ candidates.length }} aday
            </span>
          </b-card-header>
          <div
            v-if="scanSummary"
            class="px-2 py-1 border-bottom"
          >
            <div class="d-flex flex-wrap align-items-center">
              <b-badge
                variant="light-primary"
                class="mr-50 mb-50"
              >
                coin {{ scanSummary.scannedSymbols || 0 }}
              </b-badge>
              <b-badge
                variant="light-info"
                class="mr-50 mb-50"
              >
                TF {{ scanSummary.scannedTimeframes || 0 }}
              </b-badge>
              <b-badge
                variant="light-secondary"
                class="mr-50 mb-50"
              >
                raw {{ scanSummary.rawSignals || 0 }}
              </b-badge>
              <b-badge
                variant="light-success"
                class="mr-50 mb-50"
              >
                kabul {{ scanSummary.acceptedCandidates || 0 }}
              </b-badge>
              <b-badge
                variant="light-warning"
                class="mr-50 mb-50"
              >
                elenen {{ scanSummary.rejectedCandidates || 0 }}
              </b-badge>
            </div>
            <b-alert
              v-if="scanDiagnosticText"
              show
              variant="light-warning"
              class="mb-0 mt-50"
            >
              {{ scanDiagnosticText }}
              <span
                v-if="scanRejectRows.length"
                class="d-block mt-50"
              >
                {{ scanRejectRows.map(item => `${item.label}: ${item.count}`).join(' · ') }}
              </span>
            </b-alert>
          </div>
          <b-table
            responsive
            small
            :busy="scanLoading"
            :items="candidates"
            :fields="candidateFields"
            empty-text="Sinyal bulunamadı"
            show-empty
          >
            <template #cell(select)="row">
              <b-form-checkbox
                :checked="isSelected(row.item)"
                @change="toggleCandidate(row.item)"
              />
            </template>
            <template #cell(side)="row">
              <b-badge :variant="row.item.side === 'LONG' ? 'success' : 'danger'">
                {{ row.item.side }}
              </b-badge>
            </template>
            <template #cell(symbol)="row">
              <strong>{{ row.item.symbol }}</strong>
              <div class="text-muted font-small-2">
                {{ row.item.timeframe }}
              </div>
            </template>
            <template #cell(pnl)="row">
              <span :class="numberClass(row.item.currentTheoreticalPnlPct)">
                {{ fmt(row.item.currentTheoreticalPnlPct) }}%
              </span>
              <div class="text-muted font-small-2">
                MFE {{ fmt(row.item.mfePct) }} · MAE {{ fmt(row.item.maePct) }}
              </div>
            </template>
            <template #cell(momentum)="row">
              <b-badge :variant="momentumVariant(row.item.momentumBadge && row.item.momentumBadge.tone)">
                {{ row.item.momentumBadge ? row.item.momentumBadge.label : row.item.decayStatus }}
              </b-badge>
              <div class="text-muted font-small-2">
                {{ row.item.freshness }} · {{ row.item.lateEntryRisk }}
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        lg="4"
      >
        <b-card
          no-body
          class="mb-2"
        >
          <b-card-header>
            <h5 class="mb-0">
              Preview
            </h5>
          </b-card-header>
          <b-card-body>
            <b-button
              variant="outline-primary"
              block
              :disabled="!selectedCandidates.length || previewLoading"
              @click="runPreview"
            >
              <feather-icon
                icon="ShieldIcon"
                size="16"
                class="mr-50"
              />
              Risk Preview Oluştur
            </b-button>

            <div
              v-if="preview"
              class="mt-2"
            >
              <div class="d-flex justify-content-between mb-50">
                <span class="text-muted">Margin</span>
                <strong>{{ fmt(preview.totalMargin) }} USDT</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span class="text-muted">Exposure</span>
                <strong>{{ fmt(preview.totalNotionalExposure) }} USDT</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span class="text-muted">Komisyon</span>
                <strong>{{ fmt(preview.estimatedCommission) }} USDT</strong>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <span class="text-muted">Max SL</span>
                <strong class="text-danger">{{ fmt(preview.maxSlLoss) }} USDT</strong>
              </div>
              <div class="mb-1">
                <b-badge
                  variant="light-success"
                  class="mr-50"
                >
                  mevcut {{ preview.existingBotsToUse }}
                </b-badge>
                <b-badge
                  variant="light-info"
                  class="mr-50"
                >
                  oluştur {{ preview.botsToCreate }}
                </b-badge>
                <b-badge variant="light-warning">
                  skip {{ preview.skipped }}
                </b-badge>
              </div>
              <b-alert
                v-if="preview.totalMargin === 0 && preview.selectedSignals > 0"
                show
                variant="light-danger"
                class="mb-50"
              >
                Planlanan risk 0 çünkü seçili sinyaller için atanabilir bot bulunamadı veya bot oluşturma kapalı.
              </b-alert>
              <b-alert
                v-for="warning in preview.warnings"
                :key="warning"
                show
                variant="warning"
                class="mb-50"
              >
                {{ warning }}
              </b-alert>
              <div
                v-if="preview.assignmentPlans && preview.assignmentPlans.length"
                class="mb-1"
              >
                <div class="font-small-3 text-muted mb-50">
                  Atama sonucu
                </div>
                <div
                  v-for="plan in preview.assignmentPlans"
                  :key="plan.candidateId"
                  class="font-small-3 d-flex justify-content-between mb-25"
                >
                  <span>{{ plan.symbol }} {{ plan.timeframe }}</span>
                  <span :class="plan.action === 'SKIP' ? 'text-danger' : 'text-success'">
                    {{ assignmentActionLabel(plan.action) }}
                    <template v-if="plan.reasons && plan.reasons.length">
                      · {{ plan.reasons.map(rejectReasonLabel).join(', ') }}
                    </template>
                  </span>
                </div>
              </div>
              <b-button
                variant="success"
                block
                :disabled="executeLoading"
                @click="runExecute"
              >
                <feather-icon
                  icon="PlayIcon"
                  size="16"
                  class="mr-50"
                />
                Execute
              </b-button>
            </div>
          </b-card-body>
        </b-card>

        <b-card
          v-if="job"
          no-body
          class="mb-2"
        >
          <b-card-header>
            <h5 class="mb-0">
              Execution Timeline
            </h5>
          </b-card-header>
          <b-list-group flush>
            <b-list-group-item
              v-for="event in job.events"
              :key="`${event.status}-${event.at}-${event.candidateId || 'job'}`"
              class="d-flex justify-content-between align-items-start"
            >
              <div>
                <strong>{{ event.status }}</strong>
                <div class="text-muted font-small-2">
                  {{ launcherMessage(event.message || event.reason) }}
                </div>
              </div>
              <small class="text-muted">{{ shortTime(event.at) }}</small>
            </b-list-group-item>
          </b-list-group>
        </b-card>

        <b-card
          no-body
          class="mb-2"
        >
          <b-card-header class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0">
              Job History
            </h5>
            <b-button
              size="sm"
              variant="flat-secondary"
              class="p-25"
              @click="fetchJobs"
            >
              <feather-icon
                icon="RefreshCwIcon"
                size="14"
              />
            </b-button>
          </b-card-header>
          <b-list-group flush>
            <b-list-group-item
              v-for="item in jobHistory"
              :key="item.jobId"
              class="d-flex justify-content-between align-items-start"
            >
              <div>
                <b-badge :variant="item.status === 'DONE' ? 'success' : 'danger'">
                  {{ item.status }}
                </b-badge>
                <div class="font-small-3 mt-50">
                  {{ item.opened }} açıldı · {{ item.skipped }} atlandı · {{ item.failed }} hata
                </div>
                <div class="text-muted font-small-2">
                  {{ item.previewId }}
                </div>
              </div>
              <small class="text-muted">{{ shortTime(item.createdAt) }}</small>
            </b-list-group-item>
            <b-list-group-item
              v-if="!jobHistory.length"
              class="text-muted"
            >
              Henüz job yok.
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="signal-launcher-scan-modal"
      title="Sinyal tarama"
      centered
      no-close-on-backdrop
      no-close-on-esc
      :hide-header-close="scanJobActive"
      :hide-footer="scanJobActive"
      ok-only
      ok-title="Kapat"
    >
      <div v-if="scanJob">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <div>
            <strong>{{ scanJobStatusLabel }}</strong>
            <div class="text-muted font-small-3">
              {{ scanProgressText }}
            </div>
          </div>
          <b-badge :variant="scanJobBadgeVariant">
            {{ scanJob.status }}
          </b-badge>
        </div>
        <b-progress
          :value="scanProgressPercent"
          max="100"
          height="12px"
          variant="primary"
          class="mb-1"
          animated
          striped
        />
        <b-alert
          v-if="scanJob.error"
          show
          variant="danger"
          class="mb-0"
        >
          {{ scanJob.error }}
        </b-alert>
        <b-alert
          v-else-if="scanJob.status === 'DONE'"
          show
          variant="light-success"
          class="mb-0"
        >
          {{ candidates.length }} aday hazır.
          <span v-if="scanSummary">
            raw {{ scanSummary.rawSignals || 0 }} · elenen {{ scanSummary.rejectedCandidates || 0 }}
          </span>
        </b-alert>
      </div>
      <div
        v-else
        class="text-muted"
      >
        Job hazırlanıyor.
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCol,
  BFormCheckbox,
  BFormInput,
  BFormSelect,
  BListGroup,
  BListGroupItem,
  BModal,
  BProgress,
  BRow,
  BTable,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'SignalLauncherIndex',
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCol,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
    BListGroup,
    BListGroupItem,
    BModal,
    BProgress,
    BRow,
    BTable,
  },
  data() {
    return {
      scanLoading: false,
      previewLoading: false,
      executeLoading: false,
      indicators: [],
      candidates: [],
      selectedIds: [],
      scanSummary: null,
      scanJob: null,
      scanPollTimer: null,
      preview: null,
      job: null,
      jobHistory: [],
      form: {
        engineKey: 'triple-ma-forecast-signals-v1.1',
        market: 'FUTURES',
        mode: 'TESTNET',
        timeframes: '1h',
        coins: 'BTCUSDT,ETHUSDT',
        tpPerc: 2.5,
        slPerc: 1,
        leverage: 30,
        marginPerBot: 50,
        commissionPerSide: 0.05,
        candleLimit: 500,
        topNResults: 25,
      },
      filters: {
        onlyFresh: true,
      },
      assignment: {
        mode: 'AUTO_SELECT',
        maxBotsToCreate: 0,
        allowSameSymbolMultipleBots: false,
      },
      marketOptions: ['FUTURES', 'SPOT'],
      modeOptions: ['TESTNET', 'LIVE'],
      assignmentOptions: [
        { value: 'AUTO_SELECT', text: 'Sistem seçsin' },
        { value: 'CREATE_IF_NEEDED', text: 'Gerekirse bot oluştur' },
        { value: 'MANUAL', text: 'Manuel bot seç' },
      ],
      candidateFields: [
        { key: 'select', label: '' },
        { key: 'symbol', label: 'Varlık' },
        { key: 'side', label: 'Yön' },
        { key: 'pnl', label: 'PnL / MFE' },
        { key: 'momentum', label: 'Momentum' },
      ],
    }
  },
  computed: {
    indicatorOptions() {
      const base = [{ value: this.form.engineKey, text: this.form.engineKey }]
      const rows = this.indicators.map(item => ({
        value: item.engineKey,
        text: `${item.name} (${item.engineKey})`,
      }))
      return rows.length ? rows : base
    },
    selectedCandidates() {
      return this.candidates.filter(item => this.selectedIds.includes(item.candidateId))
    },
    scanRejectRows() {
      const rejects = this.scanSummary?.rejects || {}
      return Object.keys(rejects)
        .map(key => ({ key, label: this.rejectReasonLabel(key), count: rejects[key] }))
        .filter(item => item.count > 0)
        .sort((a, b) => b.count - a.count)
    },
    scanDiagnosticText() {
      if (!this.scanSummary || this.candidates.length) return ''
      if ((this.scanSummary.scannedSymbols || 0) === 0) return 'Aktif coin havuzu boş görünüyor.'
      if ((this.scanSummary.rawSignals || 0) === 0) return 'Taranan coin/timeframe içinde entry sinyali üretilmedi.'
      if (this.scanSummary.rejects?.not_fresh) return 'Sinyal bulundu ama taze sinyal filtresi eledi. Gerekirse "Sadece fresh" kapatılarak tekrar taranabilir.'
      if (this.scanSummary.rejectedCandidates) return 'Sinyal bulundu ama aktif filtrelerden biri adayları eledi.'
      return 'Aday bulunamadı.'
    },
    scanJobActive() {
      return this.scanJob && ['QUEUED', 'RUNNING'].includes(this.scanJob.status)
    },
    scanProgressPercent() {
      const progress = this.scanJob?.progress || {}
      const direct = Number(progress.percent)
      if (Number.isFinite(direct)) return Math.max(0, Math.min(100, direct))
      const current = Number(progress.current || 0)
      const total = Number(progress.total || 0)
      if (total <= 0) return this.scanJobActive ? 5 : 0
      return Math.max(0, Math.min(100, Math.round((current / total) * 100)))
    },
    scanProgressText() {
      const progress = this.scanJob?.progress || {}
      const current = progress.current || 0
      const total = progress.total || 0
      const pair = progress.symbol && progress.timeframe ? ` · ${progress.symbol} ${progress.timeframe}` : ''
      return total ? `${current}/${total}${pair}` : `${progress.stage || 'queued'}${pair}`
    },
    scanJobStatusLabel() {
      if (!this.scanJob) return 'Hazırlanıyor'
      if (this.scanJob.status === 'DONE') return 'Tarama tamamlandı'
      if (this.scanJob.status === 'FAILED') return 'Tarama hata aldı'
      return 'Tarama arka planda çalışıyor'
    },
    scanJobBadgeVariant() {
      if (!this.scanJob) return 'secondary'
      if (this.scanJob.status === 'DONE') return 'success'
      if (this.scanJob.status === 'FAILED') return 'danger'
      return 'primary'
    },
  },
  created() {
    this.fetchIndicators()
    this.fetchJobs()
  },
  beforeDestroy() {
    this.stopScanPolling()
  },
  methods: {
    async fetchIndicators() {
      try {
        const response = await axiosIns.post('/indicators', {})
        this.indicators = response.data.data || []
      } catch (err) {
        this.toast('İndikatör listesi alınamadı.', 'danger')
      }
    },
    async runScan() {
      this.scanLoading = true
      this.preview = null
      this.job = null
      this.scanSummary = null
      this.scanJob = null
      this.selectedIds = []
      try {
        const response = await axiosIns.post('/signal-launcher/scan-jobs', this.scanRequestBody())
        this.scanJob = response.data.data
        this.$bvModal.show('signal-launcher-scan-modal')
        this.startScanPolling(this.scanJob.jobId)
      } catch (err) {
        this.toast(this.errorMessage(err, 'Sinyal tarama başarısız.'), 'danger')
        this.scanLoading = false
      }
    },
    scanRequestBody() {
      return {
        engineKey: this.form.engineKey,
        market: this.form.market,
        timeframes: this.parseList(this.form.timeframes),
        coinUniverse: {
          source: 'MANUAL',
          coins: this.parseList(this.form.coins),
        },
        candleLimit: this.form.candleLimit,
        topNResults: this.form.topNResults,
        runtimeConfig: this.runtimeConfig(),
        filters: {
          onlyFresh: this.filters.onlyFresh,
          sides: ['LONG', 'SHORT'],
        },
      }
    },
    startScanPolling(jobId) {
      this.stopScanPolling()
      const tick = async () => {
        try {
          const response = await axiosIns.get(`/signal-launcher/scan-jobs/${jobId}`)
          this.scanJob = response.data.data
          if (this.scanJob.status === 'DONE') {
            this.applyScanResult(this.scanJob.result)
            this.scanLoading = false
            this.toast(this.candidates.length ? `${this.candidates.length} aday bulundu.` : `0 aday bulundu. ${this.scanDiagnosticText}`, 'success')
            return
          }
          if (this.scanJob.status === 'FAILED') {
            this.scanLoading = false
            this.toast(this.scanJob.error || 'Sinyal tarama başarısız.', 'danger')
            return
          }
          this.scanPollTimer = setTimeout(tick, 1500)
        } catch (err) {
          this.scanLoading = false
          this.toast(this.errorMessage(err, 'Sinyal tarama durumu alınamadı.'), 'danger')
        }
      }
      this.scanPollTimer = setTimeout(tick, 500)
    },
    stopScanPolling() {
      if (!this.scanPollTimer) return
      clearTimeout(this.scanPollTimer)
      this.scanPollTimer = null
    },
    applyScanResult(result) {
      this.candidates = result?.candidates || []
      this.scanSummary = result?.summary || null
      this.selectedIds = []
      this.preview = null
      this.job = null
      this.stopScanPolling()
    },
    async runPreview() {
      this.previewLoading = true
      this.preview = null
      this.job = null
      try {
        const response = await axiosIns.post('/signal-launcher/preview', {
          targetId: null,
          strategyId: null,
          mode: this.form.mode,
          market: this.form.market,
          candidates: this.selectedCandidates.map(this.toSelection),
          assignment: {
            mode: this.assignment.mode,
            allowCreateBots: this.assignment.mode === 'CREATE_IF_NEEDED',
            maxBotsToCreate: this.assignment.maxBotsToCreate,
            allowSameSymbolMultipleBots: this.assignment.allowSameSymbolMultipleBots,
            marginPerBot: this.form.marginPerBot,
          },
          runtimeConfig: this.runtimeConfig(),
          acknowledgeTargetlessRisk: true,
        })
        this.preview = response.data.data
        this.toast('Preview oluşturuldu.', 'success')
      } catch (err) {
        this.toast(this.errorMessage(err, 'Preview oluşturulamadı.'), 'danger')
      } finally {
        this.previewLoading = false
      }
    },
    async runExecute() {
      if (!this.preview) return
      this.executeLoading = true
      try {
        const response = await axiosIns.post('/signal-launcher/execute', {
          previewId: this.preview.previewId,
          idempotencyKey: this.preview.idempotencyKey,
          liveConfirm: this.preview.liveConfirmRequired,
        })
        this.job = response.data.data
        await this.fetchJobs()
        this.toast('Execution tamamlandı.', 'success')
      } catch (err) {
        this.toast(this.errorMessage(err, 'Execute başarısız.'), 'danger')
      } finally {
        this.executeLoading = false
      }
    },
    async fetchJobs() {
      try {
        const response = await axiosIns.post('/signal-launcher/jobs', { limit: 10 })
        this.jobHistory = response.data.data || []
      } catch (err) {
        this.jobHistory = []
      }
    },
    toggleCandidate(item) {
      if (this.isSelected(item)) {
        this.selectedIds = this.selectedIds.filter(id => id !== item.candidateId)
      } else {
        this.selectedIds = [...this.selectedIds, item.candidateId]
      }
      this.preview = null
      this.job = null
    },
    isSelected(item) {
      return this.selectedIds.includes(item.candidateId)
    },
    toSelection(item) {
      return {
        candidateId: item.candidateId,
        symbol: item.symbol,
        timeframe: item.timeframe,
        side: item.side,
        engineKey: item.engineKey,
        signalTime: item.signalTime,
        entryPrice: item.entryPrice,
        currentPrice: item.currentPrice,
        freshness: item.freshness,
        decayStatus: item.decayStatus,
        lateEntryRisk: item.lateEntryRisk,
        currentTheoreticalPnlPct: item.currentTheoreticalPnlPct,
        warnings: item.warnings || [],
      }
    },
    runtimeConfig() {
      return {
        tpPerc: this.form.tpPerc,
        slPerc: this.form.slPerc,
        leverage: this.form.leverage,
        marginPerBot: this.form.marginPerBot,
        commissionPerSide: this.form.commissionPerSide,
      }
    },
    parseList(value) {
      return String(value || '')
        .split(/[,\n]/)
        .map(item => item.trim().toUpperCase())
        .filter(Boolean)
    },
    momentumVariant(tone) {
      const map = {
        SUCCESS: 'success',
        NEUTRAL: 'secondary',
        WARNING: 'warning',
        DANGER: 'danger',
      }
      return map[tone] || 'secondary'
    },
    numberClass(value) {
      const num = Number(value || 0)
      if (num > 0) return 'text-success'
      if (num < 0) return 'text-danger'
      return 'text-muted'
    },
    fmt(value) {
      const num = Number(value || 0)
      return num.toFixed(2)
    },
    shortTime(value) {
      if (!value) return '—'
      return new Date(value).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })
    },
    errorMessage(err, fallback) {
      return err?.response?.data?.message || fallback
    },
    rejectReasonLabel(reason) {
      const labels = {
        no_candles: 'mum yok',
        no_entry_signal: 'entry yok',
        not_fresh: 'fresh değil',
        max_signal_age_bars: 'bar yaşı yüksek',
        max_signal_age_minutes: 'süre yaşı yüksek',
        min_score: 'skor düşük',
        min_confidence: 'güven düşük',
        decay_status: 'decay filtresi',
        side_filter: 'yön filtresi',
        bot_disabled: 'bot pasif',
        bot_not_available: 'bot müsait değil',
        bot_locked: 'bot kilitli',
        bot_cooldown: 'bot cooldown',
        position_already_open: 'pozisyon açık',
        symbol_mismatch: 'coin uyumsuz',
        timeframe_mismatch: 'timeframe uyumsuz',
        market_mismatch: 'market uyumsuz',
        mode_mismatch: 'mod uyumsuz',
        target_mismatch: 'hedef uyumsuz',
        insufficient_margin: 'margin yetersiz',
        symbol_exposure_limit: 'coin exposure limiti',
        manual_bot_not_selected: 'manuel bot seçilmedi',
        duplicate_signal: 'mükerrer sinyal',
        stale_signal: 'taze değil',
        decaying_signal: 'zayıflayan sinyal',
        live_confirm_missing: 'LIVE onay eksik',
        exchange_error: 'borsa hatası',
        target_binding_missing: 'hedef bağı eksik',
        ambiguous_assignment: 'atama belirsiz',
      }
      return labels[reason] || reason
    },
    assignmentActionLabel(action) {
      const labels = {
        USE_EXISTING_BOT: 'mevcut bot',
        CREATE_BOT: 'bot oluştur',
        SKIP: 'atlandı',
      }
      return labels[action] || action
    },
    launcherMessage(message) {
      if (!message) return '—'
      const text = String(message)
      const exact = {
        ambiguous_assignment: 'atama belirsiz',
        assignment_skipped: 'atama atlandı',
        live_confirm_missing: 'LIVE onay eksik',
      }
      if (exact[text]) return exact[text]
      return text
        .replace('candidate not found for assignment plan', 'aday atama planında bulunamadı')
        .replace('assignment skipped', 'atama atlandı')
        .replace('bot locked for manual signal launcher execution', 'bot manuel sinyal çalıştırma için kilitlendi')
        .replace('existing bot selected', 'mevcut bot seçildi')
        .replace('bot created', 'bot oluşturuldu')
        .replace('entry order sent', 'entry emri gönderildi')
        .replace('opened', 'açıldı')
        .replace('execution queued for', 'çalıştırma kuyruğa alındı:')
        .replace('signal(s)', 'sinyal')
        .replace('failed', 'hata')
        .replace('skipped', 'atlandı')
    },
    toast(text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: variant === 'danger' ? 'Hata' : 'Bilgi',
          icon: variant === 'danger' ? 'XIcon' : 'CheckIcon',
          text,
          variant,
        },
      })
    },
  },
}
</script>
